/* eslint-disable no-unused-vars */
import { useDispatch, useSelector } from 'react-redux';
import { handleProductInputArray } from '../../../redux/products/productsActions';

export default function OptionsList({ item, level, children }) {
    const dispatch = useDispatch();
    const categories = useSelector((state) => state.products.productInputData.categories);
    const productCategories = useSelector((state) => state.products.productCategories);

    const handleChangeInput = (name, id, e = null) => {
        const find = categories.findIndex((itemSelected) => itemSelected.id === id);
        if (find > -1) {
            categories.splice(find, 1);
        } else {
            categories.push(productCategories.find((newItem) => newItem.id === id));
        }

        //    console.log(categories);
        dispatch(handleProductInputArray(name, categories, e));
    };
    return (
        <>
            <div>
                <div style={{ marginLeft: level * 30 }}>
                    <input
                        type="checkbox"
                        id="categories"
                        name="categories"
                        // value={item.id}
                        onChange={() => handleChangeInput('categories', item.id)}
                        selected={categories.some((category) => category.id === item.id)}
                        checked={categories.some((category) => category.id === item.id)}
                    />
                    &nbsp;&nbsp;&nbsp;<span className="text-sm font-light">{item.name}</span>
                </div>
                <div>{children}</div>
            </div>
        </>
    );
}
